import { useEffect, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { getRandomSaintId } from "../services/saints";

export default function Random() {
  const navigate = useNavigate();
  const ranRef = useRef(false);
  const [params] = useSearchParams();
  const excludeId = params.get("exclude") || null;

  useEffect(() => {
    if (ranRef.current) return;
    ranRef.current = true;

    (async () => {
      // Try a few times in case randomness returns the same id
      let id = await getRandomSaintId({ excludeId });
      let tries = 0;

      while (excludeId && id === excludeId && tries < 5) {
        id = await getRandomSaintId({ excludeId });
        tries += 1;
      }

      if (!id || (excludeId && id === excludeId)) {
        return navigate("/search", { replace: true });
      }

      navigate(`/profile/${id}`, { replace: true });
    })();
  }, [navigate, excludeId]);

  return <div>Finding a random saint…</div>;
}
